module.exports = __webpack_public_path__ + "static/media/ROYGBIV_logo.db485a4d.jpg";